import React from 'react';

import styles from './styles.module.scss';
import logo from "~assets/logo-cbc-outline.svg";

function Footer() {
  return (
    <div className={styles.footer}>
      <a href="/home">
        <img className={styles.logo} src={logo} alt="Corredor Bioceánico de Capricornio"/>
      </a>
    </div>
  );
}

export default Footer;
